export const stipeKey: string = 'pk_test_4ZSCjcNITngIpu9K0b6cxEyy';

// Google reCAPTCHA v2 (invisible) site key — same key Magazine/auth apps use;
// pairs with the backend CaptchaPrivateKey. Used by the "Questions?" help modal.
export const RECAPTCHA_PUBLIC_KEY: string = '6LfHpEAUAAAAAMkPNzp5m_-6zOD7RC4apC0Eigqh';
